module.exports = __webpack_public_path__ + "img/trial1-2.e42b3c5c.png";